var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBoard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-board",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipboard-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.688,0H2.2A2.2,2.2,0,0,0,0,2.193v1.1A2.191,2.191,0,0,0,2.193,5.483H7.688A2.191,2.191,0,0,0,9.882,3.29v-1.1A2.183,2.183,0,0,0,7.688,0Z",
    transform: "translate(9.053 2.333)",
    fill: "#222227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M16.275.86A3.381,3.381,0,0,1,12.9,4.232H7.42A3.381,3.381,0,0,1,4.048.86.871.871,0,0,0,2.765.1,5.217,5.217,0,0,0,0,4.71V15.689A5.228,5.228,0,0,0,5.215,20.9h9.893a5.228,5.228,0,0,0,5.215-5.215V4.71A5.217,5.217,0,0,0,17.558.1.871.871,0,0,0,16.275.86ZM10.6,15.012H5.495a.875.875,0,0,1,0-1.75H10.6a.875.875,0,0,1,0,1.75Zm3.057-4.667H5.495a.875.875,0,0,1,0-1.75h8.167a.875.875,0,0,1,0,1.75Z",
    transform: "translate(3.838 4.763)",
    fill: "#222227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H28V28H0Z",
    transform: "translate(28 28) rotate(180)",
    fill: "none",
    opacity: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoard);
export default __webpack_public_path__ + "static/media/icon-board.fd62301285c675daa6a6adc27a2733aa.svg";
export { ForwardRef as ReactComponent };